interface IconProps {
  size?: number;
  color?: string;
}

export function LaptopIcon({ size = 24, color = 'currentColor' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <line x1="2" y1="20" x2="22" y2="20" />
      <line x1="7" y1="16" x2="7" y2="20" />
      <line x1="17" y1="16" x2="17" y2="20" />
    </svg>
  );
}
